<app-progress-spinner [enabled]="!shiftTurnover" />

@if (shiftTurnover) {
  <div id="printMe">
    <div>
      <div>
        <button
          pButton
          label="Print"
          class="small-margin"
          (click)="print()"
        ></button>
      </div>
      <div class="no-padding-top-bottom">
        <span class="label">{{ 'CRM.LABEL.SHIFT_CHANGE' | translate }}:</span>
        <span class="free-text-value"
          >{{ shiftTurnover.ShiftType?.name }}
        </span>
      </div>
      <div class="no-padding-top-bottom">
        <span class="label">{{ 'CRM.LABEL.AOR' | translate }}:</span>
        <span class="free-text-value">{{ shiftTurnover.aor }} </span>
      </div>
      <div class="no-padding-top-bottom">
        <span class="label">{{ 'CRM.LABEL.CREATED_DATE' | translate }}:</span>
        <span class="free-text-value"
          >{{ shiftTurnover.createdAt | date: 'MM/dd/yyyy hh:mm:ss a' }}
          {{ timezone }}
        </span>
      </div>
      <div class="no-padding-top-bottom">
        <span class="label">{{ 'CRM.LABEL.SHIFT_DATE' | translate }}:</span>
        <span class="free-text-value"
          >{{ shiftTurnover.shiftDate | date: 'MM/dd/yyyy' }} {{ timezone }}
        </span>
      </div>
      <div class="no-padding-top-bottom">
        <span class="label">{{ 'CRM.LABEL.STATUS' | translate }}:</span>
        <span class="free-text-value">{{ statusValue }} </span>
      </div>
      <div class="no-padding-top-bottom">
        <span class="label"
          >{{ 'CRM.LABEL.DEPARTING_ANALYST' | translate }}:</span
        >
        <span class="free-text-value">{{ departingAnalyst }} </span>
      </div>
      <div class="no-padding-top-bottom">
        <span class="label"
          >{{ 'CRM.LABEL.INCOMING_ANALYST' | translate }}:</span
        >
        <span class="free-text-value">{{ incomingAnalyst }} </span>
      </div>
    </div>
    <div class="no-padding-top-bottom">
      @if (shiftTurnover.departingCompletedDate) {
        <div class="no-padding-top-bottom">
          <span class="no-padding-top-bottom bold"
            >{{ 'CRM.LABEL.DEPARTING_COMPLETED_DATE' | translate }}:</span
          >
          <span class="no-padding-top-bottom"
            >{{
              shiftTurnover.departingCompletedDate
                | date: 'MM/dd/yyyy hh:mm:ss a'
            }}
            {{ timezone }}</span
          >
        </div>
      }
      @if (shiftTurnover.incomingCompletedDate) {
        <div class="no-padding-top-bottom">
          <span class="no-padding-top-bottom bold"
            >{{ 'CRM.LABEL.INCOMING_COMPLETED_DATE' | translate }}:</span
          >
          <span class="no-padding-top-bottom"
            >{{
              shiftTurnover.incomingCompletedDate
                | date: 'MM/dd/yyyy hh:mm:ss a'
            }}
            {{ timezone }}</span
          >
        </div>
      }
    </div>
    @if (shiftTurnover.ShiftDetails.length > 0) {
      <div class="no-padding-top-bottom">
        <div></div>
        <div class="bold">{{ 'CRM.LABEL.DEPARTING_ANALYST' | translate }}:</div>
        @for (item of itemsArray; track item; let j = $index) {
          <div
            class="no-padding-top-bottom"
            style="border-top: thin solid #dedede"
          >
            <div>
              <div class="no-padding-top-bottom bold">
                {{ item['itemName'] }}
              </div>
              <div>
                {{ item['departingTurnoverFlag'] ? 'Yes' : 'No' }}
              </div>
              <div>
                {{ item['departingComments'] }}
              </div>
            </div>
          </div>
        }
        <div style="border-top: thin solid #dedede">
          <div
            class="no-padding-top-bottom bold"
            [translate]="'CRM.LABEL.ADDITIONAL_COMMENTS'"
          ></div>
          <div>
            {{ detailsObj['departingAdditionalComments'] }}
          </div>
        </div>
      </div>
    }
    <p style="page-break-before: always"></p>
    <div>
      @if (unacknowledged.length > 0) {
        <p-panel header="{{ 'CRM.LABEL.UNACKNOWLEDGED_MOCS' | translate }}">
          <div>
            <div class="bold">Start Date</div>
            <div class="bold">End Date</div>
            <div class="bold">Title</div>
            @for (moc of unacknowledged; track moc; let j = $index) {
              <div
                class="no-padding-top-bottom"
                style="border-top: thin solid #dedede"
              >
                <div>
                  <div>
                    {{ moc['startDt'] | date: 'MM/dd/yyyy' }} {{ timezone }}
                  </div>
                  <div>
                    {{ moc['endDt'] | date: 'MM/dd/yyyy' }} {{ timezone }}
                  </div>
                  <div>{{ moc['title'] }} {{ timezone }}</div>
                </div>
              </div>
            }
          </div></p-panel
        >
      }
      <br />
      @if (acknowledgedAndUpcoming.length > 0) {
        <p-panel
          header="{{ 'CRM.LABEL.ACKNOW_AND_UPCOMING_MOCS' | translate }}"
        >
          <div>
            <div class="bold">Start Date</div>
            <div class="bold">End Date</div>
            <div class="bold">Title</div>
            @for (moc of acknowledgedAndUpcoming; track moc; let j = $index) {
              <div
                class="no-padding-top-bottom"
                style="border-top: thin solid #dedede"
              >
                <div>
                  <div>
                    {{ moc['startDt'] | date: 'MM/dd/yyyy' }} {{ timezone }}
                  </div>
                  <div>
                    {{ moc['endDt'] | date: 'MM/dd/yyyy' }} {{ timezone }}
                  </div>
                  <div>
                    {{ moc['title'] }}
                  </div>
                </div>
              </div>
            }
          </div>
        </p-panel>
      }
    </div>
    <div id="page-break">
      @if (shiftTurnover.ShiftDetails.length > 0) {
        <p-panel header="{{ 'CRM.LABEL.DEPARTING_ANALYST' | translate }}">
          <div>
            <div>
              <span
                class="no-padding-top-bottom bold"
                [translate]="'CRM.LABEL.PREPARED_TO_LOG_OFF_SCADA'"
              >
              </span>
              <span class="no-padding-top-bottom">
                {{ detailsObj?.departingScadaFlag ? 'Yes' : 'No' }}
              </span>
            </div>
            <div>
              <span
                class="no-padding-top-bottom bold"
                [translate]="'CRM.LABEL.FIT_TO_DRIVE'"
              >
              </span>
              <span class="no-padding-top-bottom">
                {{ detailsObj?.departingFitFlag ? 'Yes' : 'No' }}
              </span>
            </div>
            <div>
              <span
                class="no-padding-top-bottom bold"
                [translate]="'CRM.LABEL.FATIGUE_MITIGATIONS'"
              >
              </span>
              @for (item of mitArray; track item; let j = $index) {
                <span class="no-padding-top-bottom">
                  <span>
                    <span class="label">{{ item['mitigationName'] }}</span>
                    <span>
                      {{ item['turnoverFlag'] ? 'Yes' : 'No' }}
                    </span>
                  </span>
                </span>
              }
            </div>
          </div>
        </p-panel>
      }
      <br />
      @if (
        shiftTurnover.ShiftDetails.length > 0 && shiftTurnover.status !== 'N'
      ) {
        <p-panel header="{{ 'CRM.LABEL.INCOMING_ANALYST' | translate }}">
          <div>
            <div>
              <span
                class="no-padding-top-bottom bold"
                [translate]="'CRM.LABEL.PREPARED_TO_LOG_ONTO_SCADA'"
              >
              </span>
              <span class="no-padding-top-bottom">
                {{ detailsObj?.incomingScadaFlag ? 'Yes' : 'No' }}
              </span>
            </div>
            <div>
              <span
                class="no-padding-top-bottom bold"
                [translate]="'CRM.LABEL.FIT_TO_WORK'"
              >
              </span>
              <span class="no-padding-top-bottom">
                {{ detailsObj?.incomingFitFlag ? 'Yes' : 'No' }}
              </span>
            </div>
            <div>
              <span
                class="question-label bold"
                [translate]="'CRM.LABEL.REVIEWED_ITEMS_WITH_DEPARTING'"
              >
              </span>
              <span class="no-padding-top-bottom">
                {{ detailsObj?.incomingReviewedAllSections ? 'Yes' : 'No' }}
              </span>
            </div>
            <div>
              <span
                class="question-label bold"
                [translate]="'CRM.LABEL.ADDITIONAL_COMMENTS'"
              >
              </span>
              <div>
                {{ detailsObj['incomingAdditionalComments'] }}
              </div>
            </div>
          </div>
        </p-panel>
      }
    </div>
  </div>
}
